"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { Image } from "next/dist/client/image-component"
import { Desktop, Mobile, NewText } from "ui"
import { extractProperty, extractPropertyMediaItems, getUmbracoMediaUrl } from "utils"
import LandingLeadForm from "./LandingLeadForm"

const StyledFormWrapper = styled.div`
  background-color: #ededeb;
  height: 100%;
  color: ${(props) => props.theme.colors.black};
  ${(props) => props.theme.breakpoints.up("md")} {
    max-height: 100vh;
    overflow-y: auto;
  }
`

const StyledImageSwapper = styled.div`
  position: relative;
  width: 201px;
  height: 241px;
  margin: 0 auto;
  margin-top: 54px;
  margin-bottom: 33px;
`

const StyledTitlesWrapper = styled(Box)`
  padding: 0px 29px 0px 21px;
  margin-bottom: 10px;
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-bottom: 81px;
  }
`

const StyledBottomLogosWrapper = styled(Box)`
  padding: 23px 28px 32px 21.11px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  flex-wrap: wrap;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 48px 24px 24px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding: 48px 43px 24px 40px;
  }
`

const StyledBottomLogos = styled(Image)`
  height: 50px;
  min-width: 95px;
  width: fit-content;
  object-fit: contain;
  object-position: left;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 68px;
    min-width: 158px;
    object-position: center;
  }
`

type Props = {
  locale: string
  data: any
  companyId?: number
  companyName?: string
  messages?: any
}

export const LandingFormSide: React.FC<Props> = ({ data, messages, locale }: Props) => {
  const pageLogo = extractProperty(data, "pageLogo")
  const pageTitle = extractProperty(data, "pageTitle")
  const shortDescription = extractProperty(data, "shortDescription")
  const bottomLogos = extractPropertyMediaItems(data, "bottomLogos")
  const pageForm = extractProperty(data, "pageForm")?.[0]?.properties
  const bmbyId = pageForm?.find((property: any) => property.propertyName === "bmbyId")
    ?.propertyValue?.value
  const formTitle = pageForm?.find((property: any) => property.propertyName === "fromTitle")
    ?.propertyValue?.value
  const formTextForMeiling = pageForm?.find(
    (property: any) => property.propertyName === "formTextForMeiling",
  )?.propertyValue?.value
  const formTextForSms = pageForm?.find(
    (property: any) => property.propertyName === "formTextForSms",
  )?.propertyValue?.value
  const formTextForTerms = pageForm
    ?.find((property: any) => property.propertyName === "formTextForTerms")
    ?.propertyValue?.richText?.replace(
      `/${locale === "he" ? "he-il" : "en-us"}/properties/pages`,
      locale === "he" ? "" : "/en",
    )

  return (
    <StyledFormWrapper id="landingLeadForm">
      <Desktop>
        <StyledImageSwapper>
          <Image
            src={getUmbracoMediaUrl(pageLogo)}
            alt="page logo"
            width={500}
            height={500}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
            }}
            priority={true}
          />
        </StyledImageSwapper>
        <StyledTitlesWrapper>
          <NewText
            component={"h1"}
            desktopFontSize={37.14}
            desktopLineHeight={"61.65px"}
            desktopFontWeight={500}
            inheritColor
            textAlign={"center"}
            letterSpacing={"-0.01em"}
          >
            {pageTitle}
          </NewText>
          <NewText
            component={"h2"}
            desktopFontSize={22.79}
            desktopLineHeight={"24.2px"}
            desktopFontWeight={500}
            inheritColor
            marginTop={"1px"}
            textAlign={"center"}
            letterSpacing={"-0.015em"}
          >
            {shortDescription}
          </NewText>
        </StyledTitlesWrapper>
      </Desktop>
      <LandingLeadForm
        messages={messages}
        bmbyId={bmbyId}
        title={formTitle}
        formTextForMeiling={formTextForMeiling}
        formTextForTerms={formTextForTerms}
        formTextForSms={formTextForSms}
      />
      <StyledBottomLogosWrapper>
        {bottomLogos?.map((logo: string, key: number) => (
          <StyledBottomLogos
            key={key}
            src={getUmbracoMediaUrl(logo)}
            alt="footer logos"
            width={500}
            height={500}
            priority={true}
          />
        ))}
        <Mobile sx={{ width: "100%" }}>
          <NewText
            component={"p"}
            desktopFontSize={12.5}
            desktopLineHeight={"15px"}
            letterSpacing={"-0.01em"}
            inheritColor
            width={"100%"}
            marginTop={"23.6px"}
          >
            * הדמיות להמחשה בלבד. ט.ל.ח.
          </NewText>
        </Mobile>
      </StyledBottomLogosWrapper>
    </StyledFormWrapper>
  )
}

export default LandingFormSide
